import { useRef } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';

export default function ConfirmCloseCouncilDialog({ visible, setVisible, onConfirm, onHide }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const toast = useRef(null);

  const hide = () => {
    if (onHide) {
      onHide();
    } else {
      setVisible([false, true]);
    }
  };
  const accept = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      navigate(-1);
      setVisible([false, false]);
    }
  };

  const message = (
    <div>
      <p>{t('council.confirmClose.firstMessage')}</p>
      <p className="font-semibold">{t('council.confirmClose.secondMessage')}</p>
    </div>
  );

  const footer = (
    <div>
      <Button label={t('council.confirmClose.accept')} onClick={accept} autoFocus />
    </div>
  );

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        draggable={false}
        visible={visible}
        className="p-text-center w-4"
        onHide={() => hide()}
        message={message}
        header={t('council.confirmClose.header')}
        footer={footer}
      />
    </>
  );
}

ConfirmCloseCouncilDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  onHide: PropTypes.func,
};

ConfirmCloseCouncilDialog.defaultProps = {
  onConfirm: null,
  onHide: null,
};
